import React from 'react';

const s = {
  page: {
    width: '210mm', minHeight: '297mm', padding: '10mm 12mm',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    fontSize: '9px', color: '#1a1a1a', lineHeight: '1.35', background: '#fff',
  },
  header: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start',
    borderBottom: '3px solid #0f172a', paddingBottom: '8px', marginBottom: '10px',
  },
  companyName: { fontSize: '20px', fontWeight: '800', color: '#0f172a', letterSpacing: '2px' },
  companySubtitle: { fontSize: '8px', color: '#64748b', marginTop: '1px' },
  docTitle: { fontSize: '13px', fontWeight: '700', color: '#0f172a', textAlign: 'right' },
  docNumber: { fontSize: '15px', fontWeight: '800', fontFamily: 'monospace', textAlign: 'right', marginTop: '1px' },
  sectionTitle: {
    fontSize: '10px', fontWeight: '700', color: '#0f172a', textTransform: 'uppercase',
    letterSpacing: '1px', borderBottom: '1.5px solid #cbd5e1',
    paddingBottom: '3px', marginBottom: '6px', marginTop: '12px',
  },
  subSection: {
    fontSize: '9px', fontWeight: '700', color: '#334155', borderBottom: '1px dashed #e2e8f0',
    paddingBottom: '2px', marginBottom: '4px', marginTop: '8px',
  },
  infoGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '4px 14px' },
  infoGrid4: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '4px 10px' },
  lbl: { fontSize: '7px', fontWeight: '600', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.5px' },
  val: { fontSize: '9px', fontWeight: '500', color: '#1e293b' },
  valBold: { fontSize: '9px', fontWeight: '700', color: '#0f172a' },
  valMono: { fontSize: '9px', fontWeight: '600', color: '#0f172a', fontFamily: 'monospace' },
  table: { width: '100%', borderCollapse: 'collapse', marginTop: '4px', fontSize: '8px' },
  th: {
    background: '#0f172a', color: '#fff', padding: '4px 5px', textAlign: 'left',
    fontSize: '7px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px',
  },
  td: { padding: '4px 5px', borderBottom: '1px solid #e2e8f0', verticalAlign: 'top' },
  tdMono: { fontFamily: 'monospace', fontWeight: '600' },
  tdR: { textAlign: 'right' },
  totalRow: { fontWeight: '700', background: '#f1f5f9' },
  badge: (p) => ({
    display: 'inline-block', padding: '1px 6px', borderRadius: '3px', fontSize: '8px', fontWeight: '700',
    background: p === 'urgent' ? '#dc2626' : p === 'high' ? '#f97316' : '#e2e8f0',
    color: p === 'urgent' || p === 'high' ? '#fff' : '#475569',
  }),
  qualityBox: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '6px', marginTop: '4px' },
  qStat: { textAlign: 'center', padding: '5px', border: '1px solid #e2e8f0', borderRadius: '3px' },
  qNum: { fontSize: '14px', fontWeight: '800' },
  qLbl: { fontSize: '7px', color: '#64748b', textTransform: 'uppercase' },
  sigArea: {
    display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '20px',
    marginTop: '20px', paddingTop: '10px', borderTop: '1.5px solid #cbd5e1',
  },
  sigLine: { borderBottom: '1px solid #94a3b8', height: '36px', marginBottom: '3px' },
  sigLbl: { fontSize: '7px', color: '#64748b', textTransform: 'uppercase', textAlign: 'center' },
  footer: {
    marginTop: '12px', paddingTop: '6px', borderTop: '1px solid #e2e8f0',
    display: 'flex', justifyContent: 'space-between', fontSize: '7px', color: '#94a3b8',
  },
  notesBox: {
    border: '1px solid #e2e8f0', borderRadius: '3px', padding: '6px',
    marginTop: '4px', minHeight: '30px', fontSize: '8px', color: '#475569',
  },
  productCard: {
    border: '1px solid #cbd5e1', borderRadius: '4px', padding: '8px',
    marginBottom: '8px', pageBreakInside: 'avoid',
  },
  productHeader: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    borderBottom: '1px solid #e2e8f0', paddingBottom: '4px', marginBottom: '6px',
  },
};

const statusLabel = (st) => {
  const m = { open: 'Aperto', in_production: 'In Produzione', partial: 'Parziale', closed: 'Chiuso', pending: 'In Attesa' };
  return m[st] || st;
};
const priorityLabel = (p) => {
  const m = { normal: 'Normale', high: 'ALTA', urgent: 'URGENTE' };
  return m[p] || p;
};

const PrintableOrder = ({ data }) => {
  if (!data) return null;
  const { order, client, order_lines, attachments, quality_summary } = data;

  const totalValue = order_lines.reduce((sum, l) => sum + (l.unit_price ? l.quantity * l.unit_price : 0), 0);

  return (
    <div style={s.page} data-testid="printable-order">
      {/* ===== HEADER ===== */}
      <div style={s.header}>
        <div>
          <div style={s.companyName}>EVOTECH</div>
          <div style={s.companySubtitle}>Lavorazioni Meccaniche di Precisione</div>
        </div>
        <div>
          <div style={s.docTitle}>ORDINE DI PRODUZIONE</div>
          <div style={s.docNumber}>{order.order_number}</div>
          <div style={{ fontSize: '8px', textAlign: 'right', marginTop: '2px' }}>
            <span style={s.badge(order.priority)}>{priorityLabel(order.priority)}</span>
            <span style={{ marginLeft: '6px', color: '#64748b' }}>{statusLabel(order.status)}</span>
          </div>
        </div>
      </div>

      {/* ===== ORDER + CLIENT INFO ===== */}
      <div style={s.sectionTitle}>Informazioni Ordine</div>
      <div style={s.infoGrid}>
        <div><div style={s.lbl}>N. Ordine</div><div style={s.valMono}>{order.order_number}</div></div>
        <div><div style={s.lbl}>Data Ordine</div><div style={s.val}>{order.order_date}</div></div>
        <div>
          <div style={s.lbl}>Consegna Richiesta</div>
          <div style={{ ...s.valBold, color: order.required_delivery_date ? '#dc2626' : '#94a3b8' }}>
            {order.required_delivery_date || '-'}
          </div>
        </div>
        <div><div style={s.lbl}>Cliente</div><div style={s.valBold}>{client?.name || '-'}</div></div>
        <div><div style={s.lbl}>Rif. Cliente</div><div style={s.val}>{order.customer_order_ref || '-'}</div></div>
        <div><div style={s.lbl}>Contatto</div><div style={s.val}>{client?.contact_name || '-'}</div></div>
      </div>

      {/* ===== ORDER LINES TABLE ===== */}
      <div style={s.sectionTitle}>Righe Ordine</div>
      <table style={s.table}>
        <thead>
          <tr>
            <th style={{ ...s.th, width: '4%' }}>#</th>
            <th style={{ ...s.th, width: '12%' }}>Codice</th>
            <th style={{ ...s.th, width: '14%' }}>Prodotto</th>
            <th style={{ ...s.th, width: '7%' }}>Rev.</th>
            <th style={{ ...s.th, width: '8%' }}>Materiale</th>
            <th style={{ ...s.th, width: '10%' }}>Lotto Cliente</th>
            <th style={{ ...s.th, width: '7%', textAlign: 'right' }}>Qta</th>
            <th style={{ ...s.th, width: '8%', textAlign: 'right' }}>Prezzo</th>
            <th style={{ ...s.th, width: '9%', textAlign: 'right' }}>Totale</th>
            <th style={{ ...s.th, width: '10%' }}>Consegna</th>
            <th style={{ ...s.th, width: '8%' }}>Stato</th>
          </tr>
        </thead>
        <tbody>
          {order_lines.map((line) => (
            <tr key={line.id}>
              <td style={{ ...s.td, ...s.tdMono }}>{line.line_number}</td>
              <td style={{ ...s.td, ...s.tdMono, fontSize: '8px' }}>{line.product_code || '-'}</td>
              <td style={s.td}>{line.product_name || '-'}</td>
              <td style={{ ...s.td, ...s.tdMono }}>{line.revision_code || '-'}</td>
              <td style={{ ...s.td, fontSize: '8px' }}>{line.material || '-'}</td>
              <td style={{ ...s.td, ...s.tdMono, fontSize: '8px' }}>{line.customer_lot || ''}</td>
              <td style={{ ...s.td, ...s.tdR, fontWeight: '600' }}>{line.quantity}</td>
              <td style={{ ...s.td, ...s.tdR }}>{line.unit_price ? line.unit_price.toFixed(2) : '-'}</td>
              <td style={{ ...s.td, ...s.tdR, fontWeight: '600' }}>
                {line.unit_price ? (line.quantity * line.unit_price).toFixed(2) : '-'}
              </td>
              <td style={{ ...s.td, fontWeight: line.delivery_date_required ? '600' : '400', color: line.delivery_date_required ? '#0f172a' : '#94a3b8' }}>
                {line.delivery_date_required || '-'}
              </td>
              <td style={s.td}>{statusLabel(line.status)}</td>
            </tr>
          ))}
          <tr style={s.totalRow}>
            <td style={s.td} colSpan={6}></td>
            <td style={{ ...s.td, ...s.tdR, fontWeight: '700' }}>{order_lines.reduce((sum, l) => sum + l.quantity, 0)}</td>
            <td style={{ ...s.td, ...s.tdR, fontWeight: '700' }}>TOTALE</td>
            <td style={{ ...s.td, ...s.tdR, fontWeight: '700' }}>{totalValue > 0 ? `EUR ${totalValue.toFixed(2)}` : '-'}</td>
            <td style={s.td} colSpan={2}></td>
          </tr>
        </tbody>
      </table>

      {/* ===== PRODUCT DETAILS (per riga) ===== */}
      <div style={s.sectionTitle}>Dettaglio Prodotti</div>
      {order_lines.map((line) => (
        <div key={`prod-${line.id}`} style={s.productCard}>
          {/* Product header */}
          <div style={s.productHeader}>
            <div>
              <span style={{ fontSize: '11px', fontWeight: '700', fontFamily: 'monospace', color: '#0f172a' }}>
                {line.product_code}
              </span>
              <span style={{ marginLeft: '8px', fontSize: '10px', color: '#334155' }}>{line.product_name}</span>
            </div>
            <div style={{ fontSize: '8px', color: '#64748b' }}>
              Riga #{line.line_number} | Rev. {line.revision_code || '-'}
              {line.customer_lot ? ` | Lotto Cliente: ${line.customer_lot}` : ''}
            </div>
          </div>

          {/* Product info grid */}
          <div style={s.infoGrid4}>
            <div><div style={s.lbl}>Descrizione</div><div style={s.val}>{line.product_description || '-'}</div></div>
            <div><div style={s.lbl}>Materiale</div><div style={s.valBold}>{line.material || '-'}</div></div>
            <div><div style={s.lbl}>Cod. Materia Prima</div><div style={s.valMono}>{line.raw_material_code || '-'}</div></div>
            <div><div style={s.lbl}>Trattamento Esterno</div><div style={s.val}>{line.external_treatment || '-'}</div></div>
            <div><div style={s.lbl}>Famiglia Prodotto</div><div style={s.val}>{line.product_family || '-'}</div></div>
            <div><div style={s.lbl}>Unita di Misura</div><div style={s.val}>{line.unit_of_measure || '-'}</div></div>
            <div><div style={s.lbl}>Data Revisione</div><div style={s.val}>{line.revision_date || '-'}</div></div>
            <div><div style={s.lbl}>Descrizione Rev.</div><div style={s.val}>{line.revision_description || '-'}</div></div>
          </div>

          {/* Document references */}
          {(line.drawing_url || line.flow_chart_url || line.work_instruction_url) && (
            <div style={{ marginTop: '4px' }}>
              <div style={{ ...s.lbl, marginBottom: '2px' }}>Documenti di Riferimento</div>
              <div style={{ display: 'flex', gap: '12px', fontSize: '8px', color: '#475569' }}>
                {line.drawing_url && <span>Disegno: {line.drawing_url}</span>}
                {line.flow_chart_url && <span>Flow Chart: {line.flow_chart_url}</span>}
                {line.work_instruction_url && <span>Istruzione: {line.work_instruction_url}</span>}
              </div>
            </div>
          )}

          {/* Technical notes */}
          {line.technical_notes && (
            <div style={{ marginTop: '4px' }}>
              <div style={s.lbl}>Note Tecniche</div>
              <div style={{ ...s.val, fontStyle: 'italic' }}>{line.technical_notes}</div>
            </div>
          )}

          {/* Work Cycle & Phases */}
          {line.work_cycles && line.work_cycles.length > 0 && (
            <>
              {line.work_cycles.map((cycle) => (
                <div key={cycle.id} style={{ marginTop: '6px' }}>
                  <div style={s.subSection}>
                    Ciclo di Lavoro: <span style={s.valMono}>{cycle.code}</span> - {cycle.description}
                  </div>
                  {cycle.phases && cycle.phases.length > 0 && (
                    <table style={s.table}>
                      <thead>
                        <tr>
                          <th style={{ ...s.th, width: '8%' }}>Fase</th>
                          <th style={{ ...s.th, width: '28%' }}>Descrizione</th>
                          <th style={{ ...s.th, width: '15%' }}>Reparto</th>
                          <th style={{ ...s.th, width: '20%' }}>Macchina</th>
                          <th style={{ ...s.th, width: '12%', textAlign: 'right' }}>Tempo (min)</th>
                          <th style={{ ...s.th, width: '17%' }}>Attrezzatura</th>
                        </tr>
                      </thead>
                      <tbody>
                        {cycle.phases.map((phase) => (
                          <tr key={phase.id}>
                            <td style={{ ...s.td, ...s.tdMono, fontWeight: '700' }}>{phase.phase_number}</td>
                            <td style={s.td}>{phase.description}</td>
                            <td style={{ ...s.td, fontWeight: '600' }}>{phase.department}</td>
                            <td style={{ ...s.td, ...s.tdMono, fontSize: '8px' }}>{phase.default_machine || '-'}</td>
                            <td style={{ ...s.td, ...s.tdR, fontWeight: '600' }}>{phase.standard_time_minutes || '-'}</td>
                            <td style={{ ...s.td, fontSize: '8px' }}>{phase.equipment || '-'}</td>
                          </tr>
                        ))}
                        <tr style={s.totalRow}>
                          <td style={s.td} colSpan={4} />
                          <td style={{ ...s.td, ...s.tdR, fontWeight: '700' }}>
                            {cycle.phases.reduce((sum, ph) => sum + (ph.standard_time_minutes || 0), 0)} min
                          </td>
                          <td style={s.td} />
                        </tr>
                      </tbody>
                    </table>
                  )}
                </div>
              ))}
            </>
          )}

          {/* Control Plans */}
          {line.control_plans && line.control_plans.length > 0 && (
            <div style={{ marginTop: '6px' }}>
              <div style={s.subSection}>Piani di Controllo</div>
              <table style={s.table}>
                <thead>
                  <tr>
                    <th style={{ ...s.th, width: '10%' }}>Codice</th>
                    <th style={{ ...s.th, width: '18%' }}>Caratteristica</th>
                    <th style={{ ...s.th, width: '10%' }}>Nominale</th>
                    <th style={{ ...s.th, width: '8%' }}>Tol -</th>
                    <th style={{ ...s.th, width: '8%' }}>Tol +</th>
                    <th style={{ ...s.th, width: '6%' }}>UM</th>
                    <th style={{ ...s.th, width: '13%' }}>Metodo</th>
                    <th style={{ ...s.th, width: '15%' }}>Strumento</th>
                    <th style={{ ...s.th, width: '7%' }}>Freq.</th>
                  </tr>
                </thead>
                <tbody>
                  {line.control_plans.map((cp) => (
                    <tr key={cp.id}>
                      <td style={{ ...s.td, ...s.tdMono, fontSize: '7px' }}>{cp.control_code}</td>
                      <td style={{ ...s.td, fontWeight: '600' }}>{cp.characteristic}</td>
                      <td style={{ ...s.td, ...s.tdMono }}>{cp.nominal_value}</td>
                      <td style={{ ...s.td, ...s.tdMono, color: '#dc2626' }}>{cp.tolerance_min}</td>
                      <td style={{ ...s.td, ...s.tdMono, color: '#16a34a' }}>{cp.tolerance_max}</td>
                      <td style={s.td}>{cp.unit_of_measure}</td>
                      <td style={s.td}>{cp.control_method}</td>
                      <td style={{ ...s.td, fontSize: '8px' }}>{cp.measuring_instrument}</td>
                      <td style={{ ...s.td, fontWeight: '600' }}>{cp.frequency}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          {/* Revision Tool List */}
          {line.revision_tools && line.revision_tools.length > 0 && (
            <div style={{ marginTop: '6px' }}>
              <div style={s.subSection}>Utensili Richiesti</div>
              <table style={s.table}>
                <thead>
                  <tr>
                    <th style={{ ...s.th, width: '7%' }}>Seq.</th>
                    <th style={{ ...s.th, width: '13%' }}>Codice</th>
                    <th style={{ ...s.th, width: '22%' }}>Descrizione</th>
                    <th style={{ ...s.th, width: '15%' }}>Fase</th>
                    <th style={{ ...s.th, width: '10%' }}>Funzione</th>
                    <th style={{ ...s.th, width: '6%' }}>Obbl.</th>
                    <th style={{ ...s.th, width: '6%' }}>Crit.</th>
                    <th style={{ ...s.th, width: '21%' }}>Note Setup</th>
                  </tr>
                </thead>
                <tbody>
                  {line.revision_tools.map((rt, ri) => (
                    <tr key={ri} style={rt.critical ? { background: '#fef2f2' } : {}}>
                      <td style={{ ...s.td, ...s.tdMono, fontWeight: '700' }}>{rt.sequence}</td>
                      <td style={{ ...s.td, ...s.tdMono, fontSize: '8px' }}>{rt.tool_code || '-'}</td>
                      <td style={s.td}>{rt.tool_description || '-'}</td>
                      <td style={s.td}>{rt.phase_description || '-'}</td>
                      <td style={s.td}>{rt.tool_function}</td>
                      <td style={{ ...s.td, textAlign: 'center', fontWeight: '700' }}>{rt.mandatory ? 'SI' : '-'}</td>
                      <td style={{ ...s.td, textAlign: 'center', fontWeight: '700', color: rt.critical ? '#dc2626' : '#64748b' }}>{rt.critical ? 'SI' : '-'}</td>
                      <td style={{ ...s.td, fontSize: '8px' }}>{rt.setup_notes || '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

        </div>
      ))}

      {/* ===== ATTACHED DOCUMENTS ===== */}
      {attachments && attachments.length > 0 && (
        <>
          <div style={s.sectionTitle}>Documenti Allegati</div>
          <table style={s.table}>
            <thead>
              <tr>
                <th style={s.th}>Documento</th>
                <th style={s.th}>Categoria</th>
                <th style={s.th}>Descrizione</th>
              </tr>
            </thead>
            <tbody>
              {attachments.map((att, idx) => (
                <tr key={idx}>
                  <td style={{ ...s.td, ...s.tdMono }}>{att.file_name}</td>
                  <td style={s.td}>{att.category || '-'}</td>
                  <td style={s.td}>{att.description || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}

      {/* ===== NOTES ===== */}
      <div style={s.sectionTitle}>Note</div>
      <div style={s.notesBox}>{order.notes || 'Nessuna nota per questo ordine.'}</div>

      {/* ===== QUALITY SUMMARY ===== */}
      <div style={s.sectionTitle}>Riepilogo Qualita</div>
      <div style={s.qualityBox}>
        <div style={s.qStat}>
          <div style={{ ...s.qNum, color: '#0f172a' }}>{quality_summary.total_controls}</div>
          <div style={s.qLbl}>Controlli Totali</div>
        </div>
        <div style={s.qStat}>
          <div style={{ ...s.qNum, color: '#10b981' }}>{quality_summary.ok_controls}</div>
          <div style={s.qLbl}>OK</div>
        </div>
        <div style={s.qStat}>
          <div style={{ ...s.qNum, color: '#ef4444' }}>{quality_summary.nok_controls}</div>
          <div style={s.qLbl}>NOK</div>
        </div>
        <div style={s.qStat}>
          <div style={{ ...s.qNum, color: quality_summary.open_nc_count > 0 ? '#ef4444' : '#10b981' }}>
            {quality_summary.open_nc_count}
          </div>
          <div style={s.qLbl}>NC Aperte</div>
        </div>
      </div>

      {/* ===== SIGNATURE AREA ===== */}
      <div style={s.sigArea}>
        <div><div style={s.sigLine} /><div style={s.sigLbl}>Resp. Produzione</div></div>
        <div><div style={s.sigLine} /><div style={s.sigLbl}>Resp. Qualita</div></div>
        <div><div style={s.sigLine} /><div style={s.sigLbl}>Operatore</div></div>
      </div>

      {/* ===== FOOTER ===== */}
      <div style={s.footer}>
        <span>Evotech S.r.l. - Documento generato il {new Date().toLocaleDateString('it-IT')}</span>
        <span>Pag. 1 di 1</span>
      </div>
    </div>
  );
};

export default PrintableOrder;
